// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useContext } from 'react';
import LanguageContext from '../../../../contexts/LanguageContext';
import S from './styles';

interface LanguagePopupProps extends React.ComponentPropsWithRef<'div'> {
  closePopup: () => void;
}

const LanguagePopup: React.FC<LanguagePopupProps> = ({ closePopup, ...props }) => {
  const languageContext = useContext(LanguageContext);

  const changeLanguage = (lang: string) => {
    closePopup();
    languageContext.setLang(lang);
    console.log({ lang });
  }

  return (
    <S.Container {...props}>
      <S.List>
        <S.Item onClick={() => changeLanguage('zh-TW')}>繁體中文</S.Item>
        <S.Item onClick={() => changeLanguage('en')}>English</S.Item>
      </S.List>
    </S.Container>
  )
}

export { LanguagePopup as default };
